import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { RoutingNames } from "../shared/enums/routes-names";
import { UserAccessRegulatorService } from "../shared/services/user-access-regulator.service";
import { b2bRedirectPath } from "../shared/guards/b2b-redirect-path";

export const indexGuard = () => {
  const router = inject(Router);
  const userAccessRegulator = inject(UserAccessRegulatorService);

  // ops dashboard
  if (userAccessRegulator.hasAccessToAdmin) {
    return router.navigate([RoutingNames.B2B_OPS, RoutingNames.B2B_OPS_DASHBOARD]);
  }

  // b2b client dashboard
  if (userAccessRegulator.hasAccessToClientB2B) {
    return router.navigate(b2bRedirectPath(userAccessRegulator));
  }

  // victim dashboard
  if (userAccessRegulator.hasAccessToVictim) {
    return router.navigate([RoutingNames.B2C_PERSONAL_ROOT]);
  }

  // open the index (landing) page as a default route for unauthorized users
  return true;
};
